import { Component, inject } from '@angular/core';

import { AccessBlockService } from '@ministrary/shared/services/access-block/access-block.service';

@Component({
  selector: 'mt-subscription-access-blocker',
  standalone: true,
  templateUrl: './subscription-access-blocker.component.html',
  styleUrl: './subscription-access-blocker.component.scss'
})
export class SubscriptionAccessBlockerComponent {
  readonly accessBlockService = inject(AccessBlockService);
}